module.exports = __webpack_public_path__ + "img/reward_3.0c03997d.png";